module.exports = __webpack_public_path__ + "static/media/Lillipup_gaussian2.4a73570e.png";